<template>
  <div class="w-full mx-auto h-fit">
    <base-card :dark="true">
      <template>
        <!-- <div class="lg:flex flex-col lg:flex-row justify-evenly w-full h-fit my-6"> -->
        <div class="grid grid-cols-2 grid-rows-none grid-flow-row gap-2 mb-4">
          <div class="flex flex-col shadow bg-white">
            <div class="flex items-center">
              <base-icon class="pl-3 pr-1 text-xl" icon="users" />
              <h3 class="self-center w-full p-2 text-base">Customer</h3>
            </div>
            <div class="flex-col bg-white justify-center h-full w-full leading-5 p-4 space-y-3">
              <div class="flex justify-between border-b pb-1">
                <span class="text-gray-500"> Customer Name:</span>
                <span>{{ tourItemData.customer_name || '-' }}</span>
              </div>
              <div class="flex justify-between border-b pb-1">
                <span class="text-gray-500"> Customer No.: </span>
                <span>{{ tourItemData.customer_no || '-' }}</span>
              </div>
              <div class="flex justify-between border-b pb-1">
                <span class="text-gray-500"> Customer Serial Number:</span>
                <span>{{ tourItemData.customer_serial_number || '-' }}</span>
              </div>
            </div>
          </div>

          <div class="flex flex-col shadow bg-white">
            <div class="flex items-center justify-start">
              <base-icon class="pl-3 pr-1 text-xl text-blue-500" icon="map-pin" />
              <h3 class="w-full p-2 text-base">Measuring Point</h3>
            </div>

            <div class="flex-col bg-white w-full leading-5 p-4 space-y-3">
              <div class="flex justify-between border-b pb-1">
                <span class="text-gray-500"> Measuring Point ID:</span>
                <span>{{ tourItemData.customer_measuring_point_id || '-' }}</span>
              </div>
              <div class="flex justify-between border-b pb-1">
                <span class="text-gray-500"> Longitude:</span>
                <span>{{ tourItemData.lng || '-' }}</span>
              </div>
              <div class="flex justify-between border-b pb-1">
                <span class="text-gray-500"> Latitude:</span>
                <span>{{ tourItemData.lat || '-' }}</span>
              </div>
              <div class="flex justify-between border-b pb-1">
                <span class="text-gray-500"> Location (city, street, zip):</span>
                <span>{{
                  Array.from([tourItemData.city, tourItemData.street, tourItemData.zip_code])
                    .filter(Boolean)
                    .join(', ')
                }}</span>
              </div>
            </div>
          </div>

          <div class="flex flex-col col-span-2 shadow">
            <div class="bg-white flex items-center justify-start">
              <base-icon class="pl-3 pr-1 text-xl text-green-600" icon="meter-icon" />
              <h3 class="self-center p-2 text-base">Meter Readout</h3>
            </div>
            <div class="flex">
              <div class="flex-col bg-white w-full leading-5 p-4 space-y-3">
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Item number:</span>
                  <span>{{ tourItemData.item_number }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Serial Number:</span>
                  <span>{{ tourItemData.meter_serial_number }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Obis Code:</span>
                  <span>{{ tourItemData.registers[0].obis_code || '-' }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Significant Length:</span>
                  <span>{{ tourItemData.significant_length || '-' }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Key:</span>
                  <span>{{ tourItemData.key || '-' }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Key Info:</span>
                  <span>{{ tourItemData.key_info || '-' }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Medium:</span>
                  <span>{{ tourItemData.medium || '-' }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Display name:</span>
                  <span>{{ tourItemData.display_name || '-' }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Min value:</span>
                  <span :class="displayRedForMinValue(tourItemData.min_value)">{{
                    tourItemData.registers[0].min_value === null?  '-' : parseFloat(tourItemData.registers[0].min_value)
                  }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Max value:</span>
                  <span :class="displayRedForMaxValue(tourItemData.max_value)">{{
                   tourItemData.registers[0].max_value === null?  '-' : parseFloat(tourItemData.registers[0].max_value)
                  }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Unit:</span>
                  <span>{{ tourItemData.unit || '-' }}</span>
                </div>
              </div>

              <div class="flex-col bg-white w-full leading-5 p-4 space-y-3">
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> State:</span>
                  <span>{{ whatStateIs(tourItemData.state) }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Volume:</span>
                  <span>{{ tourItemData.registers[0].value === null?  '-' : parseFloat(tourItemData.registers[0].value) }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Last Value:</span>
                  <span>{{tourItemData.registers[0].last_value === null?  '-' : parseFloat(tourItemData.registers[0].last_value)}}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Last Readout:</span>
                  <span>{{ formatDate(tourItemData.registers[0].last_date) || '-' }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Description:</span>
                  <span>{{ tourItemData.description || '-' }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Appendix:</span>
                  <span>{{ tourItemData.appendix || '-' }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Remark:</span>
                  <span>{{ tourItemData.remark || '-' }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Remark State:</span>
                  <span>{{ tourItemData.remark_state || '-' }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Imported on:</span>
                  <span>{{ formatDate(tourItemData.created_at) || '-' }}</span>
                </div>
                <div class="flex justify-between border-b pb-1">
                  <span class="text-gray-500"> Uploaded at:</span>
                  <span>{{ tourItemData.uploaded_at || '-' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->

        <!-- <div class="py-4 sm:flex items-center text border-b clear-right" v-if="value" v-for="(value, key, index) in clickedTourDetails" :key="`${index}`">
        <span class="sm:w-2/5 leading-5 text-secondary-dark text-base">{{ key }}:</span>
        <span v-if="(key==='created_at') || (key==='last_readout_datetime')" class="leading-5 ml-4 sm:mt-0">{{ formatDate(value) }}</span>
        <span v-else-if="(key==='value')" class="leading-5 ml-4 sm:mt-0">{{ showDataOrNot(parseFloat(value)) }}</span>
        <span v-else-if="(key==='state')" class="leading-5 ml-4 sm:mt-0">{{ whatStateIs(value) }}</span>
        <span v-else-if="(key==='max_value')" class="leading-5 ml-4 sm:mt-0"><span :class="displayRedForMaxValue(value)">{{ parseFloat(value) }}</span></span>
        <span v-else-if="(key==='min_value')" class="leading-5 ml-4 sm:mt-0"><span :class="displayRedForMinValue(value)">{{ parseFloat(value) }}</span></span>
        <span v-else-if="(key==='last_value')" class="leading-5 ml-4 sm:mt-0">{{ parseFloat(value) }}</span>
        <span v-else class="leading-5 ml-4 sm:mt-0 sm:oveflow-clip">{{ value }}</span>
      </div> -->
      </template>
    </base-card>

    <!--                <span v-if="(key==='created_at') || (key==='last_readout_datetime')">
                  <span class="">
                    <strong>{{ key }}</strong>:{{ formatDate(value) }}
                  </span>
                </span>

                <span v-else-if="(key==='state')">
                  <span class="">
                    <strong>{{ key }}</strong>:{{ whatStateIs(value) }}
                  </span>
                </span>

                <span v-else-if="(key==='max_value')">
                  <span class="">
                   <strong>{{ key }}</strong>:<span :class="displayRedForMaxValue(value)">{{ parseFloat(value) }}</span>
                  </span>
                </span>

                <span v-else-if="(key==='min_value')">
                  <span class="">
                   <strong>{{ key }}</strong>:<span :class="displayRedForMinValue(value)">{{ parseFloat(value) }}</span>
                  </span>
                </span>

               <span v-else-if="(key==='last_value')">
                  <span class="">
                   <strong>{{ key }}</strong>:<span :class="displayRedForMinValue(value)">{{ parseFloat(value) }}</span>
                  </span>
                </span>

                <span class="" v-else>
                 <strong>{{ key }}</strong>:{{ value }}
                </span>-->

    <!--      <span v-for="(key, i) in Object.keys(clickedTourDetails)">
         <div  v-if="clickedTourDetails[key] && key!='item_number'">
          <span v-if="(key==='created_at') || (key==='last_readout_datetime')"> {{ formatDate(clickedTourDetails[key]) }}</span>
          <span v-else-if="(key==='state')">{{ whatStateIs(clickedTourDetails[key]) }}</span>
          <span v-else-if="(key==='max_value')">
            <span :class="displayRedForMaxValue(clickedTourDetails[key])">{{ parseFloat(clickedTourDetails[key]) }} </span>
          </span>
          <span v-else-if="(key==='min_value')">
            <span :class="displayRedForMinValue(clickedTourDetails[key])">{{ parseFloat(clickedTourDetails[key]) }} </span>
          </span>
          <span v-else-if="(key==='last_value')">{{ parseFloat(clickedTourDetails[key]) }}</span>
          <span p v-else>{{ clickedTourDetails[key] }}</span>
         </div>
      </span>-->
  </div>
</template>

<script>
import {
  BaseButton,
  BaseButtonIcon,
  BaseCard,
  BaseFieldset,
  BaseIcon,
  BaseInput,
  BaseModal,
  BaseRadio,
  BaseSelect,
} from '@/components/base'
import Grid from '@/components/shared/Grid'
import CompanyForm from '@/components/pages/companies/CompanyForm'

export default {
  name: 'TourDetailsDrawer_ItemDetails',
  components: {
    BaseCard,
    BaseButton,
    BaseIcon,
  },
  props: {
    tourItemData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      childrenDrawerVisibility: false,
      clickedTourDetails: this.tourItemData,
    }
  },
  methods: {
    showDataOrNot(data) {
      if (data && data !== '') {
        return data
      }
      return '-'
    },

    formatDate(someDate) {
      const aDate = new Date(someDate)
      return aDate.toString() != 'Invalid Date'
        ? aDate.toLocaleString('en-GB', {timeZone: 'UTC'})
        : someDate
    },
    whatStateIs(stateValue) {
      switch (stateValue) {
        case '00':
          return 'Not Readout'
        case '01':
          return 'Readout Manual'
        case '02':
          return 'Readout Inductive'
        case '03':
          return 'Readout Radio'
        case '04':
          return 'Readout CL'
        case '05':
          return 'Readout PC'
        case '06':
          return 'Import File'
        case '10':
          return 'Not At Home'
        case '11':
          return 'Card Provided'
        case '58':
          return 'Dismounted'
        case '59':
          return 'Mounted'
      }
      return value
    },
    displayRedForMaxValue(someValue) {
      return parseFloat(someValue) < parseFloat(this.clickedTourDetails['last_value'])
        ? 'text-red-600'
        : ''
    },
    displayRedForMinValue(someValue) {
      return parseFloat(someValue) > parseFloat(this.clickedTourDetails['last_value'])
        ? 'text-red-600'
        : ''
    },
  },
}
</script>

<style scoped></style>
